export default __webpack_public_path__ + "static/media/remove.4d66ba52.png";